import SideMenu from '@/containers/side-menu/SideMenu.vue'
import SendAutuacao from '@/pages/serpro/send-autuacao/SendAutuacao'
import SerproConfig from '@/pages/serpro/config/SerproConfig'
import SerproStatus from '@/pages/serpro/serpro-status/SerproStatus'

export default  [
  {
    path: '/send-autuacao',
    name: 'SendAutuacao',
    components: {
      mainContent: SendAutuacao,
      mainMenu: SideMenu
    },
    meta: {
      role: {
        sectorId: 'serpro-send-notifications'
      },
      breadcrumb: {
        title: 'Envio de Autuações',
        paths: [
          { title: 'Serpro' },
          { title: 'Envio de Autuações' }
        ]
      }
    }
  },
  {
    path: '/serpro-status',
    name: 'SerproStatus',
    components: {
      mainContent: SerproStatus,
      mainMenu: SideMenu
    },
    meta: {
      role: {
        sectorId: 'serpro-status'
      },
      breadcrumb: {
        title: 'Acompanhamento das Autuações Enviadas',
        paths: [
          { title: 'Serpro' },
          { title: 'Acompanhamento' }
        ]
      }
    }
  },
  {
    path: '/serpro-config',
    name: 'SerproConfig',
    components: {
      mainContent: SerproConfig,
      mainMenu: SideMenu
    },
    meta: {
      role: {
        sectorId: 'notification-serpro'
      },
      breadcrumb: {
        title: 'Configurações',
        paths: [
          { title: 'Serpro' },
          { title: 'Configurações' }
        ]
      }
    }
  }
]